/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 59a99c5e (Wed Sep  2 22:08:21 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * A child associated with a potential invite.
 * @export
 * @interface PotentialInviteChild
 */
export interface PotentialInviteChild {
  /**
   * Unique identifier for the child.
   * @type number
   * @memberof PotentialInviteChild
   */
  potentialInviteChildKey: number
  /**
   * The child's first name.
   * @type string
   * @memberof PotentialInviteChild
   */
  firstName: string
  /**
   * The child's last name.
   * @type string
   * @memberof PotentialInviteChild
   */
  lastName: string
}

export function PotentialInviteChildFromJSON(json: any): PotentialInviteChild {
  return PotentialInviteChildFromJSONTyped(json, false)
}

export function PotentialInviteChildFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PotentialInviteChild {
  if (json === undefined || json === null) {
    return json
  }
  return {
    potentialInviteChildKey: json['potentialInviteChildKey'],
    firstName: json['firstName'],
    lastName: json['lastName'],
  }
}

export function PotentialInviteChildToJSON(
  value?: PotentialInviteChild | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    potentialInviteChildKey: value.potentialInviteChildKey,
    firstName: value.firstName,
    lastName: value.lastName,
  }
}
